
import Burgers from './image/Burgers/2ce7ea060488fe58c3f6b0835115f76c8c-06-lt-burger.2x.rsquare.w536.webp';
import Burgers1 from './image/Burgers/7dbb6-29.09.2016-r6-var02-double-burger-with-bacon-and-brie-720x720.jpg';
import Burgers2 from './image/Burgers/08e757c5568b2b51560890e0f96f52534a2ba258_2000x2000.webp';
import Burgers3 from './image/Burgers/2019.jpg';
import Burgers4 from './image/Burgers/OIP (1).webp';
import Burgers5 from './image/Burgers/OIP (2).webp';
import Burgers6 from './image/Burgers/OIP (3).webp';
import Burgers7 from './image/Burgers/OIP.webp';

import Chickens from './image/Chickens/853884114350737.60394d03f2d3e.jpg';
import Chickens1 from './image/Chickens/fried-chicken-with-french-fries-nuggets-meal_1339-40931.jpg';
import Chickens2 from './image/Chickens/hqdefault.jpg';
import Chickens3 from './image/Chickens/Keto-chicken-nuggets-233x290.jpg';
import Chickens4 from './image/Chickens/OIP (1).webp';
import Chickens5 from './image/Chickens/OIP (2).webp';
import Chickens6 from './image/Chickens/OIP.webp';
import Chickens7 from './image/Chickens/Spicy-Baked-Chicken-Wings-Recipe-12.webp';


import BBQ from './image/BBQ/20230112-Demand-in-Seafood-Fishery.jpg';
import BBQ1 from './image/BBQ/Chipotle-Steak-600x600.jpg';
import BBQ2 from './image/BBQ/for-the-most-flavorful-shrimp-apply-the-marinade-twice-1723612863.jpg';
import BBQ3 from './image/BBQ/GettyImages-21621909941-57dd2913fc904209911ff14dce8cda5a.webp';
import BBQ4 from './image/BBQ/i (1).webp';
import BBQ5 from './image/BBQ/i.webp';
import BBQ6 from './image/BBQ/OIP (1).webp';
import BBQ7 from './image/BBQ/OIP.webp';

import Fish from './image/Fish/61a49e44e973c0407edc5fbb47fac2a3--smoker-recipes-ethnic-food.jpg';
import Fish1 from './image/Fish/1500-Calorie-Pescatarian-Meal-Plan-370x297.jpg';
import Fish2 from './image/Fish/Grilled-Salmon-Recipe005-web.jpg';
import Fish3 from './image/Fish/grilled-tilapia-recipe_8b0475858b0c7da5839195905b3f9082-768x426.jpeg';
import Fish4 from './image/Fish/il_794xN.4726268308_23hg.webp';
import Fish5 from './image/Fish/maxresdefault.jpg';
import Fish6 from './image/Fish/OIP (1).webp';
import Fish7 from './image/Fish/OIP (2).webp';

import Pizzas from './image/Pizzas/46e81d_aee2085ef528445eb26acbec54cd3021~mv2.avif';
import Pizzas1 from './image/Pizzas/apollo-pizza.jpg';
import Pizzas2 from './image/Pizzas/big-ed-s-pizza.jpg';
import Pizzas3 from './image/Pizzas/l.jpg';
import Pizzas4 from './image/Pizzas/OIP (1).webp';
import Pizzas5 from './image/Pizzas/OIP (2).webp';
import Pizzas6 from './image/Pizzas/OIP (3).webp';
import Pizzas7 from './image/Pizzas/OIP (4).webp';


import SparklingLemonade from './image/Drinks/Sparkling Lemonade.jpeg';
import TropicalSmoothie from './image/Drinks/Tropical Smoothie2.jpeg';
import IcedMochaLatte3 from './image/Drinks/Iced Mocha Latte.jpeg';
import MintMojito from './image/Drinks/Mint Mojito.jpeg';
import FreshOrangeJuice from './image/Drinks/Fresh Orange Juice.jpeg';





export const products = [
  {
    "id": 1,
    "name": "Classic Beef Burger",
    "category": "Burgers",
    "description": "Juicy beef burger topped with melted cheese and fresh lettuce for a classic bite.",
    "price": 63.59,
    "image": Burgers,
    "rating": 4.0,
    "available": true
  },
  {
    "id": 2,
    "name": "Smoky Grill Burger",
    "category": "Burgers",
    "description": "Grilled to perfection, this burger comes with smoky sauce and crispy onions.",
    "price": 59.87,
    "image": Burgers1,
    "rating": 3.6,
    "available": false
  },
  {
    "id": 3,
    "name": "Cheese Lover Burger",
    "category": "Burgers",
    "description": "A flavorful mix of beef and cheddar with tangy pickles and secret sauce.",
    "price": 57.98,
    "image": Burgers2,
    "rating": 5.0,
    "available": false
  },
  {
    "id": 4,
    "name": "Double Stack Burger",
    "category": "Burgers",
    "description": "Double-layer burger packed with smoky flavor and crunchy toppings.",
    "price": 69.13,
    "image": Burgers3,
    "rating": 3.1,
    "available": true
  },
  {
    "id": 5,
    "name": "Spicy Beef Burger",
    "category": "Burgers",
    "description": "Savor the taste of premium beef with melted cheese and spicy mayo.",
    "price": 75.23,
    "image": Burgers4,
    "rating": 3.8,
    "available": false
  },
  {
    "id": 6,
    "name": "BBQ Onion Burger",
    "category": "Burgers",
    "description": "A bold mix of smoky beef, BBQ sauce, and caramelized onions.",
    "price": 79.39,
    "image": Burgers5,
    "rating": 4.8,
    "available": true
  },
  {
    "id": 7,
    "name": "Bacon Crunch Burger",
    "category": "Burgers",
    "description": "Crispy bacon, melted cheese, and a perfectly toasted bun—simply irresistible.",
    "price": 49.64,
    "image": Burgers6,
    "rating": 4.4,
    "available": false
  },
  {
    "id": 8,
    "name": "House Special Burger",
    "category": "Burgers",
    "description": "Classic beef burger with fresh veggies and our signature house sauce.",
    "price": 78.38,
    "image": Burgers7,
    "rating": 4.8,
    "available": true
  },
  {
    "id": 9,
    "name": "Crispy Fried Chicken",
    "category": "Chickens",
    "description": "Crispy fried chicken served with a side of creamy garlic dip.",
    "price": 58.08,
    "image": Chickens,
    "rating": 3.3,
    "available": true
  },
  {
    "id": 10,
    "name": "Herb Grilled Chicken",
    "category": "Chickens",
    "description": "Tender grilled chicken marinated in special herbs and spices.",
    "price": 81.69,
    "image": Chickens1,
    "rating": 4.6,
    "available": false
  },
  {
    "id": 11,
    "name": "Honey Glazed Chicken Bites",
    "category": "Chickens",
    "description": "Golden fried chicken bites coated with spicy honey glaze.",
    "price": 65.67,
    "image": Chickens2,
    "rating": 3.3,
    "available": true
  },
  {
    "id": 12,
    "name": "Roasted Chicken with Veggies",
    "category": "Chickens",
    "description": "Juicy roasted chicken served with grilled vegetables and lemon sauce.",
    "price": 70.29,
    "image": Chickens3,
    "rating": 3.2,
    "available": true
  },
  {
    "id": 13,
    "name": "Crispy Chicken Fillet",
    "category": "Chickens",
    "description": "Crispy chicken fillet with spicy mayo and crunchy lettuce layers.",
    "price": 62.3,
    "image": Chickens4,
    "rating": 3.1,
    "available": true
  },
  {
    "id": 14,
    "name": "Garlic Butter Wings",
    "category": "Chickens",
    "description": "Herb-seasoned chicken wings with a touch of garlic butter.",
    "price": 56.35,
    "image": Chickens5,
    "rating": 3.4,
    "available": false
  },
  {
    "id": 15,
    "name": "Smoky BBQ Tenders",
    "category": "Chickens",
    "description": "Crispy tenders with a smoky BBQ flavor and creamy dip.",
    "price": 78.04,
    "image": Chickens6,
    "rating": 4.6,
    "available": true
  },
  {
    "id": 16,
    "name": "Chili Grilled Chicken",
    "category": "Chickens",
    "description": "Perfectly grilled chicken breast served with a tangy chili sauce.",
    "price": 60.68,
    "image": Chickens7,
    "rating": 4.6,
    "available": true
  },
  {
    "id": 17,
    "name": "Smoky Ribs",
    "category": "BBQ",
    "description": "Smoky BBQ ribs glazed with rich homemade sauce and grilled onions.",
    "price": 49.99,
    "image": BBQ,
    "rating": 4.7,
    "available": true
  },
  {
    "id": 18,
    "name": "Tender BBQ Chicken",
    "category": "BBQ",
    "description": "Tender BBQ chicken with a bold smoky flavor and sweet glaze.",
    "price": 45.27,
    "image": BBQ1,
    "rating": 4.8,
    "available": false
  },
  {
    "id": 19,
    "name": "Char-Grilled Meat Slices",
    "category": "BBQ",
    "description": "Char-grilled meat slices served with roasted corn and BBQ dip.",
    "price": 57.53,
    "image": BBQ2,
    "rating": 3.6,
    "available": true
  },
  {
    "id": 20,
    "name": "Slow-Cooked Beef Ribs",
    "category": "BBQ",
    "description": "Slow-cooked beef ribs drenched in smoky BBQ sauce for meat lovers.",
    "price": 53.95,
    "image": BBQ3,
    "rating": 4.7,
    "available": false
  },
  {
    "id": 21,
    "name": "Spicy BBQ Platter",
    "category": "BBQ",
    "description": "Spicy BBQ platter with juicy wings and grilled beef skewers.",
    "price": 48.08,
    "image": BBQ4,
    "rating": 3.4,
    "available": true
  },
  {
    "id": 22,
    "name": "Smoky Meat Mix",
    "category": "BBQ",
    "description": "Perfect mix of smoky meats with tangy sauce and soft bread rolls.",
    "price": 77.73,
    "image": BBQ5,
    "rating": 3.8,
    "available": true
  },
  {
    "id": 23,
    "name": "Flame-Grilled Combo",
    "category": "BBQ",
    "description": "Flame-grilled BBQ combo packed with ribs, sausages, and sauce.",
    "price": 49.32,
    "image": BBQ6,
    "rating": 4.0,
    "available": true
  },
  {
    "id": 24,
    "name": "Tender BBQ Delight",
    "category": "BBQ",
    "description": "Soft, tender meat infused with smoky BBQ flavor and herbs.",
    "price": 59.62,
    "image": BBQ7,
    "rating": 3.8,
    "available": true
  },
  {
    "id": 25,
    "name": "Grilled Lemon Fish",
    "category": "Fish",
    "description": "Grilled fish fillet with lemon butter sauce and fresh herbs.",
    "price": 50.54,
    "image": Fish,
    "rating": 3.7,
    "available": true
  },
  {
    "id": 26,
    "name": "Crispy Tartar Fish",
    "category": "Fish",
    "description": "Crispy fried fish served with tartar sauce and salad garnish.",
    "price": 61.15,
    "image": Fish1,
    "rating": 4.0,
    "available": true
  },
  {
    "id": 27,
    "name": "Oven-Baked Herb Fish",
    "category": "Fish",
    "description": "Oven-baked fish with garlic, herbs, and a hint of olive oil.",
    "price": 46.04,
    "image": Fish2,
    "rating": 4.3,
    "available": true
  },
  {
    "id": 28,
    "name": "Citrus Glazed Salmon",
    "category": "Fish",
    "description": "Freshly grilled salmon topped with citrus glaze and greens.",
    "price": 57.89,
    "image": Fish3,
    "rating": 3.8,
    "available": true
  },
  {
    "id": 29,
    "name": "Spicy Pan-Seared Fish",
    "category": "Fish",
    "description": "Pan-seared fish with spicy seasoning and a touch of lemon zest.",
    "price": 57.59,
    "image": Fish4,
    "rating": 3.1,
    "available": true
  },
  {
    "id": 30,
    "name": "Fish Sticks & Fries",
    "category": "Fish",
    "description": "Crispy fish sticks with creamy sauce and golden fries.",
    "price": 54.91,
    "image": Fish5,
    "rating": 4.7,
    "available": false
  },
  {
    "id": 31,
    "name": "Herb-Grilled Fish Fillet",
    "category": "Fish",
    "description": "Tender fish fillet grilled with herbs and served with vegetables.",
    "price": 59.31,
    "image": Fish6,
    "rating": 3.8,
    "available": true
  },
  {
    "id": 32,
    "name": "Crispy Crumb Fish",
    "category": "Fish",
    "description": "Fried fish coated with crispy crumbs and homemade dressing.",
    "price": 82.4,
    "image": Fish7,
    "rating": 3.3,
    "available": true
  },
  {
    "id": 33,
    "name": "Pepperoni Golden Pizza",
    "category": "Pizzas",
    "description": "Cheesy pepperoni pizza baked to golden perfection.",
    "price": 72.4,
    "image": Pizzas,
    "rating": 4.9,
    "available": true
  },
  {
    "id": 34,
    "name": "Classic Margherita Pizza",
    "category": "Pizzas",
    "description": "Classic Margherita with mozzarella, basil, and tomato sauce.",
    "price": 54.52,
    "image": Pizzas1,
    "rating": 3.5,
    "available": false
  },
  {
    "id": 35,
    "name": "Loaded Veggie Pizza",
    "category": "Pizzas",
    "description": "Loaded veggie pizza with olives, peppers, and mushrooms.",
    "price": 66.09,
    "image": Pizzas2,
    "rating": 4.2,
    "available": true
  },
  {
    "id": 36,
    "name": "BBQ Chicken Pizza",
    "category": "Pizzas",
    "description": "BBQ chicken pizza topped with cheese and tangy BBQ drizzle.",
    "price": 77.95,
    "image": Pizzas3,
    "rating": 4.3,
    "available": true
  },
  {
    "id": 37,
    "name": "Spicy Meat Pizza",
    "category": "Pizzas",
    "description": "Spicy meat pizza packed with pepperoni and beef chunks.",
    "price": 51.85,
    "image": Pizzas4,
    "rating": 3.8,
    "available": true
  },
  {
    "id": 38,
    "name": "Four-Cheese Pizza",
    "category": "Pizzas",
    "description": "Four-cheese pizza with creamy mozzarella and cheddar mix.",
    "price": 77.83,
    "image": Pizzas5,
    "rating": 4.9,
    "available": true
  },
  {
    "id": 39,
    "name": "Hawaiian Pizza Delight",
    "category": "Pizzas",
    "description": "Hawaiian pizza with sweet pineapple and savory ham slices.",
    "price": 60.58,
    "image": Pizzas6,
    "rating": 4.9,
    "available": true
  },
  {
    "id": 40,
    "name": "Thin-Crust Veggie Pizza",
    "category": "Pizzas",
    "description": "Crispy thin-crust pizza topped with tomato, cheese, and herbs.",
    "price": 72.92,
    "image": Pizzas7,
    "rating": 3.4,
    "available": true
  },
  {
    "id": 41,
    "name": "Sparkling Lemonade",
    "category": "Drinks",
    "description": "Refreshing sparkling lemonade with a zesty twist of fresh lemons.",
    "price": 15.99,
    "image": SparklingLemonade,
    "rating": 4.5,
    "available": true
  },
  {
    "id": 42,
    "name": "Iced Mocha Latte",
    "category": "Drinks",
    "description": "Chilled mocha latte with creamy chocolate and espresso for coffee lovers.",
    "price": 21.49,
    "image": IcedMochaLatte3,
    "rating": 4.7,
    "available": true
  },
  {
    "id": 43,
    "name": "Fresh Orange Juice",
    "category": "Drinks",
    "description": "Cold-pressed fresh orange juice, packed with vitamin C.",
    "price": 18.75,
    "image": FreshOrangeJuice,
    "rating": 4.8,
    "available": true
  },
  {
    "id": 44,
    "name": "Mint Mojito",
    "category": "Drinks",
    "description": "Classic mint mojito with fresh lime, mint leaves, and sparkling water.",
    "price": 19.99,
    "image": MintMojito,
    "rating": 4.6,
    "available": false
  },
  {
    "id": 45,
    "name": "Tropical Smoothie",
    "category": "Drinks",
    "description": "Blend of tropical fruits for a creamy and refreshing smoothie.",
    "price": 22.3,
    "image": TropicalSmoothie,
    "rating": 4.9,
    "available": true
  }
]
